'use client';

import React, { useState } from 'react';

interface FaqItem {
  q: string;
  a: string;
}

export function HomeFaqAccordion({ faqs }: { faqs: FaqItem[] }) {
  const [activeFaq, setActiveFaq] = useState<number | null>(0);

  const toggleFaq = (idx: number) => {
    setActiveFaq(activeFaq === idx ? null : idx);
  };

  return (
    <div className="space-y-3" data-testid="home-faq-accordion">
      {faqs.map((faq, idx) => (
        <div
          key={idx}
          className="rounded-[22px] bg-gradient-to-br from-white/12 to-white/[0.025] border border-white/22 shadow-[inset_0_1px_0_rgba(255,255,255,0.3)] backdrop-blur-xl overflow-hidden transition-all duration-200"
        >
          <button
            type="button"
            onClick={() => toggleFaq(idx)}
            className="w-full text-left px-6 py-5 flex items-center justify-between gap-4 font-sans text-sm sm:text-base font-medium text-white hover:text-[#b9c6ff] transition-colors cursor-pointer"
            aria-expanded={activeFaq === idx}
          >
            <span>{faq.q}</span>
            <span className="w-7 h-7 rounded-full bg-white/15 grid place-items-center text-sm font-bold text-white shrink-0">
              {activeFaq === idx ? '−' : '+'}
            </span>
          </button>
          {activeFaq === idx && (
            <div className="px-6 pb-6 text-xs sm:text-sm text-[rgba(220,236,255,0.85)] leading-relaxed border-t border-white/10 pt-4">
              {faq.a}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
